import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fileService } from "./fileService";


// Get All File
export const getAllFile = createAsyncThunk("get/file", async (thunkAPI) => {
    try {
        return await fileService.getAllFile()
    } catch (error) {
        return thunkAPI.rejectWithValue(error)
    }
})

// Get Single File
export const getFile = createAsyncThunk("get/file/id", async (fileId, thunkAPI) => {
    try {
        return await fileService.getFile(fileId)
    } catch (error) {
        return thunkAPI.rejectWithValue(error)
    }
})


const initialState = {
    files: [],
    isLoading: false,
    isSuccess: false,
    isError: false,
    message: "",
}

export const fileSlice = createSlice({
    name: "file",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Get All File
            .addCase(getAllFile.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getAllFile.fulfilled, (state, action) => {
                state.isLoading = false
                state.isError = false
                state.isSuccess = true
                state.files = action.payload
            })
            .addCase(getAllFile.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.isSuccess = false
                state.message = action.error
            })
            
            // Get Single File
            .addCase(getFile.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getFile.fulfilled, (state, action) => {
                state.isLoading = false
                state.isError = false
                state.isSuccess = true
                state.files = action.payload
            })
            .addCase(getFile.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.isSuccess = false
                state.message = action.error
            })
            
    }
})

export default fileSlice.reducer
